import * as d3 from 'd3'
import * as dc from 'dc'
import { createEffectiveSpotMap } from '../calculations/convertNotionalToBRL.js'
import { calculateTotalVolumeBRL } from '../calculations/calculateTotalVolumeBRL.js'
import { calculateNegotiatedVolumeBRL } from '../calculations/calculateNegotiatedVolumeBRL.js'
import { calculateConvertedVolumeBRL } from '../calculations/calculateConvertedVolumeBRL.js'
import { calculateConversionRate } from '../calculations/calculateConversionRate.js'
import { calculateAverageSpreadPips } from '../calculations/calculateAverageSpreadPips.js'
import { calculateRevenueBRL } from '../calculations/calculateRevenueBRL.js'
import { formatResponsiveAmount } from './formatKpiAmount.js'

export function createTotalVolumeKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateTotalVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

// DEAL + NOTH.DONE
export function createNegotiatedVolumeKpi({ el, ndx, chartGroup, width }) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateNegotiatedVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

// DEAL
export function createConvertedVolumeKpi({ el, ndx, chartGroup, width }) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateConvertedVolumeBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createConversionRateKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateConversionRate(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(d3.format('.2f'))
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createAverageSpreadKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const group = {
    value: () => calculateAverageSpreadPips(ndx.allFiltered()),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 2)
    .formatNumber(d3.format(',.2f'))
    .valueAccessor((value) => value)

  chart.render()

  return chart
}

export function createRevenueKpi({
  el,
  ndx,
  chartGroup,
  width,
}) {
  const effectiveSpotByRow = createEffectiveSpotMap(ndx.all())

  const group = {
    value: () => calculateRevenueBRL(ndx.allFiltered(), effectiveSpotByRow),
  }

  const chart = new dc.NumberDisplay(el, chartGroup)

  chart
    .group(group)
    .width(width / 4)
    .formatNumber(formatResponsiveAmount)
    .valueAccessor((value) => value)

  chart.render()

  return chart
}
